import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tutorial from "./tutorial.vue";
import InformationalCard from "./informational-card.vue";
import InformationalModal from "./informational-modal.vue";
import DashboardCalendar from "./dashboard-calendar.vue";
import ClientsActivity from "./clients-activity.vue";

// Lazy-load chart components which are less critical for initial render
const AppsReceivedChart = () => import(/* webpackChunkName: "dashboard-charts" */"./charts/apps-received-chart.vue");
const ClosesChart = () => import(/* webpackChunkName: "dashboard-charts" */"./charts/closes-chart.vue");
const StagesChart = () => import(/* webpackChunkName: "dashboard-charts" */"./charts/stages-chart.vue");
const CompletedChart = () => import(/* webpackChunkName: "dashboard-charts" */"./charts/completed-chart.vue");
const D2lSubmissions = () => import(/* webpackChunkName: "dashboard-submissions" */"./d2l-submissions.vue");
import { mapGetters, mapActions, mapState } from "vuex";
import { LOAD_APPLICATIONS, LOAD_MORTGAGES, LOAD_ACTIVITIES, LOAD_BIRTHDAYS } from "../store/dashboard-actions";
import { GET_MORTGAGE_DAYS, GET_ACTIVITY_DAYS, GET_BIRTHDAY_DAYS, GET_ACTIVITY_EXPIRED, GET_MORTGAGE_STATUS, GET_MORTGAGE_AGENT, GET_BIRTHDAY_AGENT, GET_MORTGAGE_CLIENTS, GET_ACTIVITY_CLIENTS, GET_BIRTHDAY_CLIENTS } from "../store/dashboard-getters";
import { CURRENT_USER_DETAILS, CURRENT_USER_USERNAME, CURRENT_ACCOUNT_PREFERENCES, CURRENT_ACCOUNT_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { LOAD_AGENTS } from "../../agents/store/agent-actions";
import { CLIENT_APPLICATION_STATUS } from "./../../../../../shared/js/enum";
import Amplitude from "@Shared/utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DashboardContainer",
  title() {
    return this.$t("sidebar.sections.dashboard");
  },
  components: {
    Tutorial,
    InformationalCard,
    InformationalModal,
    DashboardCalendar,
    ClientsActivity,
    AppsReceivedChart,
    ClosesChart,
    StagesChart,
    CompletedChart,
    D2lSubmissions
  },
  data() {
    return {
      loadingItems: false,
      mortgageCardLoading: false,
      loadingDashboard: true,
      loadingSections: {
        cards: true,
        calendar: true,
        activity: true,
        charts: true
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("DashboardStore", [GET_MORTGAGE_DAYS, GET_ACTIVITY_DAYS, GET_BIRTHDAY_DAYS, GET_ACTIVITY_EXPIRED, GET_MORTGAGE_STATUS, GET_MORTGAGE_AGENT, GET_BIRTHDAY_AGENT, GET_MORTGAGE_CLIENTS, GET_ACTIVITY_CLIENTS, GET_BIRTHDAY_CLIENTS])), mapGetters("AccountStore", [CURRENT_USER_DETAILS, CURRENT_USER_USERNAME, CURRENT_ACCOUNT_PREFERENCES, CURRENT_ACCOUNT_DETAILS])), mapState("AccountStore", {
    showDirectToLender(state) {
      return state.accountDetails.showDirectToLender;
    }
  })), {}, {
    showTutorial() {
      return this.CURRENT_ACCOUNT_PREFERENCES.tutorial;
    },
    agentName() {
      return this.CURRENT_USER_DETAILS.givenName;
    },
    agentUsername() {
      return this.CURRENT_USER_USERNAME;
    },
    isBroker() {
      return this.CURRENT_ACCOUNT_DETAILS.accountType === "broker";
    },
    expired() {
      return this.GET_ACTIVITY_EXPIRED;
    },
    mortgageDays() {
      return this.GET_MORTGAGE_DAYS;
    },
    activityDays() {
      return this.GET_ACTIVITY_DAYS;
    },
    birthdayDays() {
      return this.GET_BIRTHDAY_DAYS;
    },
    mortgageStatus() {
      return this.GET_MORTGAGE_STATUS;
    },
    completedApplications() {
      return this.mortgageStatus === CLIENT_APPLICATION_STATUS.completed;
    },
    numberOfClients() {
      return {
        mortgage: this.GET_MORTGAGE_CLIENTS.length,
        activity: this.GET_ACTIVITY_CLIENTS.length,
        birthday: this.GET_BIRTHDAY_CLIENTS.length
      };
    }
  }),
  beforeMount() {
    Amplitude.logEvent("Dashboard - visited", {
      page: "dashboard"
    });
  },
  async mounted() {
    const shouldShowSpinner = sessionStorage.getItem("reloadMortgageRenewalsWithSpinner") === "true";
    if (shouldShowSpinner) {
      sessionStorage.removeItem("reloadMortgageRenewalsWithSpinner");
      this.mortgageCardLoading = true;
    }
    try {
      await this.init();
    } finally {
      this.loadingDashboard = false;
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("DashboardStore", [LOAD_APPLICATIONS, LOAD_MORTGAGES, LOAD_ACTIVITIES, LOAD_BIRTHDAYS])), mapActions("BoardStore", [LOAD_BOARDS])), mapActions("AgentStore", [LOAD_AGENTS])), {}, {
    async init() {
      const agentUsername = this.agentUsername;
      const promises = [this.LOAD_APPLICATIONS({
        agentUsername: this.isBroker ? "" : agentUsername
      }), this.LOAD_BOARDS({
        data: {
          agentUsername
        }
      })];
      if (this.isBroker) {
        promises.push(this.LOAD_AGENTS());
      }
      await _Promise.all(promises);
    },
    async loadMortgages({
      days,
      agentUsername = "",
      completed
    }) {
      this.loadingItems = true;
      try {
        await this.LOAD_MORTGAGES({
          agentUsername: agentUsername || this.GET_MORTGAGE_AGENT,
          days,
          completed
        });
      } catch (error) {
        console.error("Error loading mortgages:", error);
      } finally {
        this.loadingItems = false;
      }
    },
    async loadActivities({
      days,
      expired = false
    }) {
      this.loadingItems = true;
      try {
        await this.LOAD_ACTIVITIES({
          days,
          expired
        });
      } catch (error) {
        console.error("Error loading activities:", error);
      } finally {
        this.loadingItems = false;
      }
    },
    async loadBirthdays({
      days,
      agentUsername = ""
    }) {
      this.loadingItems = true;
      try {
        await this.LOAD_BIRTHDAYS({
          days,
          agentUsername: agentUsername || this.GET_MORTGAGE_AGENT
        });
      } catch (error) {
        console.error("Error loading birthdays:", error);
      } finally {
        this.loadingItems = false;
      }
    },
    openMortgageModal() {
      this.$refs.mortgageModal.show();
    },
    openActivityModal() {
      this.$refs.activityModal.show();
    },
    openBirthdayModal() {
      this.$refs.birthdayModal.show();
    },
    goToSettings() {
      window.location = "#/personal-settings";
    }
  })
});